// extracted by mini-css-extract-plugin
module.exports = {"text-section":"text-section_text-section__ursHu"};